import { Select } from "antd";
import { useAtom } from "jotai";
import { parentConditionsQueryAtom } from "../../services/queries";
import { useEffect, useState } from "react";

const ParentConditionSelector = ({ onChange, record }) => {
  const [
    {
      data: parentConditionsData,
      isError: isParentConditionsDataError,
      isLoading: isParentConditionsDataLoading,
      isPending: isParentConditionsDataPending,
    },
  ] = useAtom(parentConditionsQueryAtom, {
    delay: 0,
  });

  const [categoryOptions, setCategoryOptions] = useState([]);

  useEffect(() => {
    if (parentConditionsData) {
      let options = parentConditionsData
        .filter((elem, idx) => elem.uid !== record?.uid)
        .map((opt, index) => {
          return { label: opt.name, value: opt.uid };
        });
      setCategoryOptions(options);
    }
  }, [parentConditionsData]);

  return (
    <>
      <Select
        value={record?.parentUid ?? undefined}
        onChange={onChange}
        showSearch
        style={{
          minWidth: "5vw",
          minHeight: "2rem",
        }}
        placeholder="Select parent category of condition"
        filterOption={(input, option) => {
          var _a;
          return ((_a = option?.label) ?? "")
            .toLowerCase()
            .includes(input.toLowerCase());
        }}
        options={categoryOptions}
      />
    </>
  );
};

export default ParentConditionSelector;
